import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { getUserTypeName } from "../../admin/navigation/adminNavigation";
import { ASSETS, NAV_LINKS, SERVICE_LINKS } from "./data/landingData";

const DASHBOARD_BY_ROLE = {
  CUSTOMER: "/customer/workspace",
  PARTNER: "/partner/workspace",
};

const LandingNavbar = () => {
  const user = useSelector((state) => state.auth.user);
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const isLoggedIn = Boolean(user && (user.refreshToken || user.token || user.accessToken || user.user));
  const role = String(getUserTypeName(user) || "").toUpperCase();
  const dashboardPath = DASHBOARD_BY_ROLE[role] ?? "/admin";
  const close = () => setExpanded(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      as="header"
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={setExpanded}
      className={`lp-navbar${scrolled ? " is-scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={close} aria-label="All Home Desire home">
          <img src={ASSETS.logo} alt="All Home Desire" className="lp-navbar__logo" height="36" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="lp-nav-collapse" aria-label="Toggle navigation" />
        <Navbar.Collapse id="lp-nav-collapse">
          <Nav className="mx-lg-auto align-items-lg-center gap-lg-1" as="nav" aria-label="Main navigation">
            {NAV_LINKS.map(({ to, label }) => (
              <Nav.Link key={to} as={NavLink} to={to} end={to === "/"} onClick={close}>
                {label}
              </Nav.Link>
            ))}
            <NavDropdown title="Services" id="lp-services-dropdown">
              {SERVICE_LINKS.map(({ to, label, divider }) => (
                <div key={to}>
                  {divider && <NavDropdown.Divider />}
                  <NavDropdown.Item as={Link} to={to} onClick={close}>
                    {label}
                  </NavDropdown.Item>
                </div>
              ))}
            </NavDropdown>
            <Nav.Link as={NavLink} to="/contactus" onClick={close}>
              Contact Us
            </Nav.Link>
          </Nav>
          <Link
            to={isLoggedIn ? dashboardPath : "/login"}
            onClick={close}
            className="lp-btn lp-btn--primary lp-navbar__cta"
          >
            {isLoggedIn ? "Dashboard" : "Login / Get Started"}
          </Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default LandingNavbar;
